// extracted by mini-css-extract-plugin
export default {"IonButton":"Button_IonButton__CneQA"};